import React from 'react';
import useModal from '../../../hooks/use-modal';
import { Books } from '../../../svg';
import VideoModal from '../popup-modal/video-modal';
import {Link} from "react-router-dom";

const CourseDetailsSidebar = ({ course,details_2=false, isSubscribed, subscribedCourse }) => {
    const {     id="",
        image240x135 = "",
        contentInfo= "",
        numOfPublishedLectures = 0,
        numArticles= 0,
        numAdditionalResources = 0,
        numCodingExercise = 0,
        numPracticeTests = 0} = course || {};
    const { isVideoOpen, setIsVideoOpen } = useModal();
    return (
        <>
            <div className={`course-sidebar-3 ${details_2?'':'sidebar-top-position'}`}>
                <div className="edu-course-widget widget-course-summery">
                    <div className="inner">
                        <div className="thumbnail">
                            {image240x135 ?
                                <img className="image" src={image240x135} alt="course-image" /> :
                                <img className="image" src="/assets/images/placeholderImage.jpg" alt="course-image"/>
                            }
                            {/*<a onClick={() => setIsVideoOpen(true)} style={{ cursor: 'pointer' }} className="play-btn video-popup-activation">*/}
                            {/*    <i className="icon-18"></i>*/}
                            {/*</a>*/}
                        </div>
                        <div className="content">
                            <h4 className="widget-title">Kurs İçeriği:</h4>
                            <ul className="course-item">
                                {/*<li>*/}
                                {/*    <span className="label"><i className="icon-60"></i>Price:</span>*/}
                                {/*    <span className="value price">${course_price}</span>*/}
                                {/*</li>*/}

                                {/*<li>*/}
                                {/*    <span className="label"><i className="icon-62"></i>Instrutor:</span>*/}
                                {/*    <span className="value">{instructor}</span>*/}
                                {/*</li>*/}

                                <li>
                                    <span className="label"><i className="icon-61"></i>Süre:</span>
                                    <span className="value">{contentInfo}</span>
                                </li>

                                <li>
                                    <span className="label"><Books />Dersler:</span>
                                    <span className="value">{numOfPublishedLectures}</span>
                                </li>

                                {/*<li>*/}
                                {/*    <span className="label"><i className="icon-63"></i>Enrolled:</span>*/}
                                {/*    <span className="value">{student} students</span>*/}
                                {/*</li>*/}

                                {/*<li>*/}
                                {/*    <span className="label"><i className="icon-59"></i>Language:</span>*/}
                                {/*    <span className="value">{language}</span>*/}
                                {/*</li>*/}

                                {/*<li>*/}
                                {/*    <span className="label"><i className="icon-64"></i>Certificate:</span>*/}
                                {/*    <span className="value">{certificate}</span>*/}
                                {/*</li>*/}
                            </ul>

                            <div className="read-more-btn" style={{cursor: "pointer"}}>
                                {isSubscribed ?
                                    <a href={`/course/view/${id}`} className="edu-btn">Kursa Devam Et <i className="icon-4"></i></a>
                                    :
                                    <a className="edu-btn" onClick={subscribedCourse}>Hemen Kaydolun <i className="icon-4"></i></a>
                                }
                            </div>

                            {/*<div className="share-area">*/}
                            {/*    <h4 className="title">Share On:</h4>*/}
                            {/*    <ul className="social-share">*/}
                            {/*        <li><a href="#"><i className="icon-facebook"></i></a></li>*/}
                            {/*        <li><a href="#"><i className="icon-twitter"></i></a></li>*/}
                            {/*        <li><a href="#"><i className="icon-linkedin2"></i></a></li>*/}
                            {/*        <li><a href="#"><i className="icon-youtube"></i></a></li>*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>

            {/* video modal start */}
            {/*<VideoModal isVideoOpen={isVideoOpen} setIsVideoOpen={setIsVideoOpen} videoId={videoId} />*/}
            {/* video modal end */}
        </>
    )
}

export default CourseDetailsSidebar;